import React from 'react'
import { Box, Typography } from '@material-ui/core'
import Container from 'ui/Container'

const Title = ({
  children,
  variant = 'h4',
  color = 'textSecondary',
  containerTitleProps,
  ...props
}) => (
  <Container {...containerTitleProps}>
    <Box mb={2} textAlign="center" {...props}>
      <Typography variant={variant} component="h1" color={color} {...props}>
        {children}
      </Typography>
    </Box>
  </Container>
)

export default Title
